import { useState, useEffect } from "react";
import { useApiClient } from "./useApiClient";
import { getTodayTimeRange } from "../utils/dateUtils";
import { apiRoutes } from "../api/routes";

export const useNotificationCount = () => {
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const apiClient = useApiClient();

  const fetchNotificationCount = async () => {
    setIsLoading(true);
    try {
      const { start, end } = getTodayTimeRange();
      const requestBody = {
        select: ["id"],
        query: [
          ["between", "timestamp", start, end],
          ["null", "resolve_timestamp"],
          [
            "in",
            "type",
            [
              0, 1, 2, 4, 5, 6, 13, 14, 15, 18, 19, 20, 21, 22, 23, 24, 25, 26, 28, 29, 30, 31, 32,
              33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 100, 101,
            ],
          ],
        ],
        options: {
          timeout: 10,
          limit: 0,
          calculate_total: true,
          return_results: false,
          select_distinct: true,
        },
      };

      const response = await apiClient.post(apiRoutes.proxy("support/internal/alert/select_query"), requestBody);

      if (response.data && response.data.info) {
        setNotificationCount(response.data.info?.total_results);
      } else {
        setError("Failed to fetch notification count");
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 60000);

    return () => clearInterval(interval);
  }, []);

  return { notificationCount, isLoading, error };
};
